import React, { useState, useEffect } from 'react';
import { NavLink, Link, useLocation } from 'react-router-dom';
import { useIsMobile } from '../hooks/useIsMobile';

const links = [
  { to: '/work',     label: 'Work' },
  { to: '/services', label: 'What I Offer' },
  { to: '/about',    label: 'About' },
  { to: '/contact',  label: 'Contact' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen]         = useState(false);
  const isMobile                = useIsMobile();
  const location                = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  const isHome = location.pathname === '/';

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0, zIndex: 200,
        background: open ? 'transparent' : 'rgba(248,247,244,0.96)',
        backdropFilter: open ? 'none' : 'blur(10px)',
        borderBottom: !open && scrolled ? '1px solid var(--rule)' : '1px solid transparent',
        transition: 'border-color 300ms, background 300ms',
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          padding: isMobile ? '0 1.5rem' : '0 3rem',
          height: '56px',
        }}>
          <Link to="/" style={{
            
            
            fontSize: isMobile ? '15px' : '17px',
            color: open ? 'white' : 'var(--ink)',
            letterSpacing: '-0.01em',
            transition: 'color 250ms',
            flexShrink: 0,
          }}>
            Liam Boyd Creative Studio
          </Link>

          {isMobile ? (
            <button
              onClick={() => setOpen(o => !o)}
              aria-label={open ? 'Close menu' : 'Open menu'}
              style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px', display: 'flex', flexDirection: 'column', gap: '5px', zIndex: 201 }}
            >
              <span style={{ display: 'block', width: '22px', height: '1px', background: open ? 'white' : 'var(--ink)', transition: 'transform 280ms ease, background 250ms', transform: open ? 'translateY(6px) rotate(45deg)' : 'none' }} />
              <span style={{ display: 'block', width: '22px', height: '1px', background: open ? 'white' : 'var(--ink)', transition: 'opacity 280ms ease, background 250ms', opacity: open ? 0 : 1 }} />
              <span style={{ display: 'block', width: '22px', height: '1px', background: open ? 'white' : 'var(--ink)', transition: 'transform 280ms ease, background 250ms', transform: open ? 'translateY(-6px) rotate(-45deg)' : 'none' }} />
            </button>
          ) : (
            <ul style={{ display: 'flex', gap: '2.5rem', listStyle: 'none' }}>
              {links.map(({ to, label }) => (
                <li key={to}>
                  <NavLink to={to} style={({ isActive }) => ({
                    
                    fontSize: '12px',
                    fontWeight: 300,
                    letterSpacing: '0.06em',
                    color: isActive ? 'var(--ink)' : 'var(--ink-faint)',
                    transition: 'color 150ms',
                  })}>
                    {label}
                  </NavLink>
                </li>
              ))}
            </ul>
          )}
        </div>
      </nav>

      {/* Full-screen mobile overlay */}
      <div style={{
        position: 'fixed', inset: 0, zIndex: 199,
        background: 'var(--ink)',
        display: 'flex', flexDirection: 'column',
        padding: '7rem 1.5rem 3rem',
        opacity: open ? 1 : 0,
        pointerEvents: open ? 'auto' : 'none',
        transition: 'opacity 300ms ease',
      }}>
        <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
          {links.map(({ to, label }, i) => (
            <li key={to} style={{ opacity: open ? 1 : 0, transform: open ? 'translateY(0)' : 'translateY(20px)', transition: `opacity 350ms ease ${i * 60}ms, transform 350ms ease ${i * 60}ms` }}>
              <NavLink to={to} style={({ isActive }) => ({
                
                
                fontSize: '42px',
                lineHeight: 1.2,
                color: isActive ? 'rgba(255,255,255,0.4)' : 'white',
                display: 'block',
              })}>
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
        <div style={{ marginTop: 'auto' }}>
          <a href="mailto:liam@liamboyd.com" style={{
            
            fontSize: '12px',
            fontWeight: 300,
            letterSpacing: '0.06em',
            color: 'rgba(255,255,255,0.35)',
          }}>
            liam@liamboyd.com
          </a>
        </div>
      </div>
    </>
  );
}
